import { Avatar, Stack, Text, useColorModeValue,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  Button,
  PopoverBody,
  Box,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { MdMessage } from "react-icons/md";
import thelogo from "../../assets/thelogo.png";
import { useState } from "react";
import OnlineState from "../../components/OnlineState";
import { changeSingleMemberRole, removeMemberFromGroup } from "../dashboard/tradingGroup/service";
import { successNotifier } from "../..";
import DeleteGroupMemberModal from "../../components/profile/components/DeleteGroupMemberModal";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useGetState } from "../../context/useGetState";

function GroupMembers({ groupChat, groupMembers, user }) {
  const text1Color = useColorModeValue("#4B5155", "#4B5155");
  const text2Color = useColorModeValue("#4B5155", "#898989");
  const bgColor = useColorModeValue("#F9FAFC", "#030c1b");
  const bg2Color = useColorModeValue("#DBE5ED", "#030c1b");
  const borderColor = useColorModeValue("#DBE5ED", "#030c1b");
  const arrowColor = useColorModeValue("#AFBBC6", "#AFBBC6");
  const navigate = useNavigate();
  const [toggle, setToggle] = useState(true);
  const [groupUser, setGroupUser] = useState(undefined);
  const [deleteGroupMemberModalOpen, setDeleteGroupMemberModalOpen] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [memberToDelete, setMemberToDelete] = useState(undefined);

  const { state } = useGetState();
  const userInfo = state?.userInfo;

  //console.log('groupChat: ', groupChat);

  const handleMessageUser = (member) => {
    // if (!isLoggedIn) {
    //   window.location.href = "/";
    //   return;
    // }
    const recipientData = {
      recipient: member,
      last_message: null,
      unread_messages: []
    }

    const data = [
      recipientData
    ]
    //console.log('formedRecipient: ', data);
   
    localStorage.setItem('privateChatRecipient', JSON.stringify(data))
    // navigate("/messaging11", {
    //   state: { privateChatRecipient: { user } },
    // });
    navigate("/messaging");
    //console.log('another: ', user);
  };

  const handleChangeSingleMemberRoleToAdmin = async (selectedGroup, selectedUser) => {
    const formData = new FormData()
    formData.append('role', 'moderator')
    try {
      const res = await changeSingleMemberRole(selectedGroup?.id, selectedUser?.id, formData);
      successNotifier(`Successfully Added ${selectedUser?.name}, as Admin in ${selectedGroup?.name}`);
      setGroupUser(res?.data)
      //console.log('res: ', res);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const handleChangeSingleMemberRoleToMember = async (selectedGroup, selectedUser) => {
    const formData = new FormData()
    formData.append('role', 'member')
    try {
      const res = await changeSingleMemberRole(selectedGroup?.id, selectedUser?.id, formData);
      successNotifier(`Successfully Removed ${selectedUser?.name}, as Admin in ${selectedGroup?.name}`);
      setGroupUser(res?.data)
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const handleRemoveMemberFromGroup = async (selectedGroup, selectedUser) => {
    
    try {
      const res = await removeMemberFromGroup(selectedGroup?.id, selectedUser?.id);
      successNotifier(`Successfully Removed ${selectedUser?.name}, from ${selectedGroup?.name}`);
      setIsDeleted(true)
      //setGroupUser(res?.data)
    } catch (error) {
      console.error("Error:", error);
    }
  }


  return (
    <Stack spacing={"20px"}>
      <Stack
        direction={"row"}
        alignItems="center"
        justifyContent={"space-between !important"}
      >
        <Text color={text2Color}>Group Members</Text>
        <Stack
          bg={bg2Color}
          p="5px"
          borderRadius={"3px"}
          cursor="pointer"
          onClick={() => setToggle((init) => !init)}
        >
          {toggle ? (
            <IoMdArrowDropdown color="#7B8793" />
          ) : (
            <IoMdArrowDropup color="#7B8793" />
          )}
        </Stack>
      </Stack>
      {toggle &&
        groupMembers?.map((member, key) => {
          return (
            <Stack
              display={memberToDelete && memberToDelete?.id == member?.id &&  isDeleted && ("none")}
              key={member?.id}
              direction={"row"}
              alignItems="center"
              justifyContent={"space-between"}
              borderRadius="8px"
              p="5px"
            >
              <Stack
                direction={"row"}
                alignItems="center"
                justifyContent={"space-between !important"}
                w="100%"
              >

                <Stack
                  direction={"row"}
                  alignItems="center"
                  cursor={"pointer"}
                  onClick={() => {
                    navigate(`/view-profile/${member?.id}`);
                  }}
                >
                <Avatar
                  border={"2px solid #fff"}
                  size={"xs"}
                  objectFit={"cover"}
                  fallbackSrc={thelogo}
                  src={member?.picture}
                  name={member?.username}
                  alt="user pic"
                />
                <Stack alignItems={"flex-start"} spacing="0" flex="3">
                  <Text color={text1Color} fontSize=".8em">
                    {member?.id === user?.id ? "You" : member?.username}
                  </Text>
                  <OnlineState
                    //id={member?.user?.firebase_token}
                  />
                </Stack>

                </Stack>

                <Stack direction={"row"} alignItems="center">
                  <Text fontSize={"10px"}>
                    {parseInt(groupChat?.creator?.id) === member?.id
                      ? "Admin"
                      : "Member"}
                  </Text>
                  {member?.id !== user?.id && (
                    // <MdMessage
                    //   display={"none"}
                    //   cursor={"pointer"}
                    //   color="#7CD892"
                    //   fontSize={"1.2em"}
                    //   onClick={() => handleMessageUser(member)}
                    // />
                    

                  <Popover
                  closeOnBlur={true}
                  placement='bottom'

                  >
                  <PopoverTrigger>
                  <Stack
                      style={{ border:"1px solid #fff", borderRadius:"50%", padding:"2px" }}
                    >
                      <BsThreeDotsVertical
                      color={arrowColor}
                      fontSize={"0.8em"}
                      cursor="pointer"
                      />
                    </Stack>
                  </PopoverTrigger>
                  <PopoverContent color='white' bg='#07182E' border='0' width={"100%"}>
                    <PopoverArrow />
                    <PopoverBody border='0'>
                      {/* Add your popover content here, e.g., a menu */}
                      <Stack
                          display='block'
                          alignItems='center'
                          justifyContent='space-between'
                      >
                        {groupUser === undefined && parseInt(groupChat?.creator?.id) === userInfo?.id && (
                          <Box fontSize='xs' textAlign={'center'} cursor={'pointer'}
                            _hover={{ color: "#ffffff40" }}
                            onClick={() => handleChangeSingleMemberRoleToAdmin(groupChat, member)} 
                          >
                            Make Group Admin
                          </Box>
                        )}

                        {/* {groupUser && groupUser?.user_id == member?.id && ( */}
                        {groupUser && parseInt(groupChat?.creator?.id) === userInfo?.id && (
                          <Box fontSize='xs' textAlign={'center'} cursor={'pointer'}
                            _hover={{ color: "#ffffff40" }}
                            onClick={() =>
                              groupUser?.role === "member"
                                ? handleChangeSingleMemberRoleToMember(groupChat, member)
                                : handleChangeSingleMemberRoleToAdmin(groupChat, member)
                            }
                          >
                            {groupUser?.role === "member" ? "Make Group Admin" : "Remove As Group Admin"}
                          </Box>
                        )}

                        {/* {groupUser && groupUser?.user_id != member?.id && ( */}
                        {/* {groupUser && parseInt(groupChat?.creator?.id) !== userInfo?.id && (
                          <Box fontSize='xs' textAlign={'center'} cursor={'pointer'}
                            _hover={{ color: "#ffffff40" }}
                            onClick={() =>
                              groupUser?.role === "member"
                                ? handleChangeSingleMemberRoleToMember(groupChat, member)
                                : handleChangeSingleMemberRoleToAdmin(groupChat, member)
                            }
                          >
                            {groupUser?.role === "member" ? "Make Group Admin2" : "Make Group Admin3"}
                          </Box>
                        )} */}

                        <Box fontSize='xs' textAlign={'center'} cursor={'pointer'} _hover={{ color: "#ffffff40" }}
                        onClick={() => {
                          navigate(`/view-profile/${member?.id}`);
                        }}
                        >View {member?.username}</Box>

                        <Box fontSize='xs' textAlign={'center'} cursor={'pointer'} _hover={{ color: "#ffffff40" }}
                        onClick={() => handleMessageUser(member)}
                        >
                          Message {member?.username}
                        </Box>

                        {parseInt(groupChat?.creator?.id) === userInfo?.id && 
                        <Box fontSize='xs' textAlign={'center'} cursor={'pointer'} _hover={{ color: "#ffffff40" }}
                        //onClick={() => handleRemoveMemberFromGroup(groupChat, member)}
                        onClick={ () => {
                          setMemberToDelete(member)
                          setDeleteGroupMemberModalOpen(true)
                        }}
                        >Remove {member?.username}</Box>}
                      </Stack>
                      
                    </PopoverBody>
                  </PopoverContent>
                  </Popover>

                    
                  )}
                </Stack>
              </Stack>

            </Stack>
          );
        })}

      <DeleteGroupMemberModal
        authUserId={user?.id} groupData={groupChat} member={memberToDelete} handleRemoveMemberFromGroup={handleRemoveMemberFromGroup}
        isOpen={deleteGroupMemberModalOpen && memberToDelete} onClose={() => setDeleteGroupMemberModalOpen(false)} setIsDeleted={setIsDeleted} 
      />
    </Stack>
  );
}

export default GroupMembers;
